export function Panel({ title, accent, icon: Icon, children, wide }) {
  return (
    <div className={`rounded-3xl border-2 border-ink bg-white shadow-pop-sm p-6 ${wide ? "lg:col-span-2" : ""}`}>
      <div className="flex items-center gap-2 mb-4">
        <div className="h-9 w-9 rounded-xl border-2 border-ink grid place-items-center" style={{ background: accent }}>
          <Icon size={17} />
        </div>
        <h3 className="font-extrabold text-lg">{title}</h3>
      </div>
      {children}
    </div>
  );
}

export function Row({ title, sub, onApprove, onDeny, testid }) {
  return (
    <div className="py-3 border-b border-[#ECE7D8] last:border-0 flex items-center justify-between gap-3" data-testid={testid}>
      <div className="min-w-0">
        <div className="font-bold truncate">{title}</div>
        <div className="text-xs text-muted-foreground truncate">{sub}</div>
      </div>
      <div className="flex gap-2 shrink-0">
        <button onClick={onApprove} className="h-8 px-4 rounded-full border-2 border-ink text-xs font-bold press" style={{ background: "#B8FF3B" }}>Approve</button>
        <button onClick={onDeny} className="h-8 px-4 rounded-full border-2 border-ink text-xs font-bold press bg-white">Deny</button>
      </div>
    </div>
  );
}

export function Stat({ label, value, color }) {
  return (
    <div className="rounded-3xl border-2 border-ink bg-white p-5 shadow-pop-sm">
      <div className="h-2 w-10 rounded-full mb-3" style={{ background: color }} />
      <div className="text-3xl font-extrabold leading-none">{value}</div>
      <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mt-1">{label}</div>
    </div>
  );
}

export const Empty = ({ text }) => <p className="text-sm text-muted-foreground py-2">{text}</p>;
export const Skeleton = () => <div className="h-72 rounded-3xl border-2 border-ink bg-white/60 animate-pulse" />;
